import { Trophy, Shield } from 'lucide-react';
import { Team } from '../../types';
import { formatPairName } from '../../lib/utils';

interface ChampionBadgeProps {
  champion: Team | null;
  onClick?: (id: string) => void;
}

export function ChampionBadge({ champion, onClick }: ChampionBadgeProps) {
  if (!champion) return null;
  return (
    <div
      className="inline-flex items-center gap-2 md:gap-3 bg-gradient-to-r from-yellow-400/20 to-yellow-600/20 border border-yellow-400/50 px-3 md:px-4 py-1.5 md:py-2 rounded-full cursor-pointer hover:scale-105 transition-transform shadow-lg max-w-full"
      onClick={(e) => {
        e.stopPropagation();
        onClick && onClick(champion.id);
      }}
    >
      <Trophy size={18} className="text-yellow-400 drop-shadow-md shrink-0" />
      <div className="flex flex-col items-start leading-none text-left min-w-0">
        <span className="text-[9px] text-yellow-500 font-black uppercase tracking-widest mb-0.5">Campeón</span>
        <span className="text-white font-black text-sm drop-shadow-md whitespace-nowrap">
          {formatPairName(champion.name, 'short')}
        </span>
      </div>
      {champion.photoUrl ? (
        <img
          src={champion.photoUrl}
          className="w-7 h-7 rounded-full object-cover ml-1 border border-yellow-400/50 shrink-0"
          alt="logo"
        />
      ) : (
        <Shield size={16} className="text-yellow-400 ml-1 shrink-0" />
      )}
    </div>
  );
}
